<template>
  <div>
    <v-skeleton-loader v-if="loading && this.transferencia" type="article"></v-skeleton-loader>
    <v-card v-else>
      <v-card-title>
        {{ transferencia.descripcion ? transferencia.descripcion : 'Sin descripcion' }}
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Fecha y Hora</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                    $moment(transferencia.fechaAlta).format("dddd D [de] MMMM Y H:m")
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Origen</th>
                <th class="text-left">Destino</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                    transferencia.origen.nombre
                  }}
                </td>
                <td>
                  {{
                    transferencia.destino.nombre
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense v-if="transferencia.dolares">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" v-if="transferencia.dolares.precioVenta">Precio de Venta</th>
                <th class="text-left" v-else>Precio de Compra USD</th>
                <th class="text-left">Precio por Unidad USD</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-if="transferencia.dolares.precioVenta">
                  $ {{
                    transferencia.dolares.precioVenta
                  }}
                </td>
                <td v-else>
                  $ {{
                    transferencia.dolares.precioCompra
                  }}
                </td>
                <td>
                  $ {{
                    transferencia.dolares.precioUnidad
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Monto</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ transferencia.dolares ? 'USD' : '$'}} {{
                    transferencia.monto
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "Gastos_Ver",
  data() {
    return {
      transferencia: {
        descripcion: "",
      },
      loading: true,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  async created() {
    this.loading = true;
    try {
      const transferencia = await this.axios.get(`/transferencia/${this.id}`);
      this.transferencia = transferencia.data;
    } catch (error) {
      console.log(error);
    }
    this.loading = false;
  },
  methods: {
      _cerrar() {
          this.$router.go(-1);
      }
  },
};
</script>
